import { ChatUser } from "@virtualprogaming/js-public-sdk";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { CurrentMembers } from "./CurrentMembers";
import { SearchMembers } from "./SearchMembers";

export const MembersPopup: FC<{
  chatId: number;
  isConversationAdmin: boolean;
  isGlobal: boolean;
  shouldNotShowAction: boolean;
  onClose: () => void;
  members: ChatUser[];
}> = ({
  chatId,
  isConversationAdmin = false,
  isGlobal = false,
  shouldNotShowAction = false,
  onClose,
  members,
}) => (
  <div className="bg-light">
    <CurrentMembers
      members={members ?? []}
      onClose={onClose}
      chatId={chatId}
      isGlobal={isGlobal}
      isConversationAdmin={isConversationAdmin}
      shouldNotShowRemove={shouldNotShowAction}
    />
    {shouldNotShowAction ? null : (
      <h6 className="font-variant-small-caps pd-l-md mg-t-sm">
        <FormattedMessage defaultMessage="Add new members" id="5zgvJw" />
      </h6>
    )}
    {shouldNotShowAction ? null : (
      <SearchMembers
        chatId={chatId}
        shouldUseSystem={isGlobal && isConversationAdmin}
      />
    )}
  </div>
);
